import { render, staticRenderFns } from "./roleform.vue?vue&type=template&id=2340eaac&scoped=true&"
import script from "./roleform.vue?vue&type=script&lang=js&"
export * from "./roleform.vue?vue&type=script&lang=js&"
import style0 from "./roleform.vue?vue&type=style&index=0&id=2340eaac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2340eaac",
  null
  
)

export default component.exports